import React from "react";
import "./notfound.css";

const Participants = () => {
  return (
    <>
      <div className="participants-page">
        <div className="tab-header">
          <div className="left-section">

            <div className="title headline-small">404 Not Found</div>

          </div>
        </div>
      </div>
    </>
  );
};

export default Participants;
